var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ElementsSizeProvider", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ setSize, getBlockMinHeight }) {
          return [
            _c(
              "div",
              { staticClass: "flex flex-row flex-wrap gap-4 mb-8" },
              _vm._l(_vm.activities, function (activity, index) {
                return _c("VisitsListCard", {
                  key: activity.id,
                  attrs: {
                    activity: activity,
                    companyId: _vm.companyId,
                    currentUser: _vm.currentUser,
                    declinedMatches: _vm.getDeclinedMatchesForActivity
                      ? _vm.getDeclinedMatchesForActivity(activity.id)
                      : [],
                    bookmarkedContractors:
                      _vm.getBookmarkedContractorsForActivity
                        ? _vm.getBookmarkedContractorsForActivity(activity.id)
                        : [],
                    descriptionBlockHeight: getBlockMinHeight({
                      id: activity.id,
                      blockName: "description",
                      index,
                    }),
                  },
                  on: {
                    visitUpdated: _vm.visitUpdated,
                    "update:descriptionBlockHeight": (minHeight) =>
                      setSize({
                        id: activity.id,
                        blockName: "description",
                        minHeight,
                        index,
                      }),
                    projectUpdated: function ($event) {
                      return _vm.$emit("projectUpdated")
                    },
                    openActivityModal: function ($event) {
                      return _vm.$emit("openActivityModal", $event)
                    },
                  },
                })
              }),
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }